import { isEmpty, isString } from 'lodash';

import { Spin } from 'antd';
import { RcFile } from 'antd/es/upload';

export const updateObject = (oldObject: any, updatedProperties: any) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const GuidEmpty = '00000000-0000-0000-0000-000000000000';

export const validateGuid = (possibleGuid: string | undefined) => {
  return !!possibleGuid && isString(possibleGuid) && !isEmpty(possibleGuid) && possibleGuid !== GuidEmpty ? possibleGuid : undefined;
};

export const isGuid = (guidValue: string | undefined) => {
  return !isEmpty(guidValue) && isString(guidValue) && guidValue !== GuidEmpty;
};

export const escapeRegex = (string: string) => {
  return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
};

export const renderNoDataOrSpinner = (isLoading: boolean | undefined) => {
  return isLoading ? (
    <span style={{ display: 'block', textAlign: 'center' }}>
      <Spin size="small" />
    </span>
  ) : (
    <span style={{ display: 'block', textAlign: 'center' }}> No Data </span>
  );
};

export const getImageUrlFromBytes = (bytes: Uint8Array | ArrayBuffer | undefined | null) => {
  if (bytes && bytes.byteLength > 0) {
    const blob = new Blob([bytes]);
    const url = URL.createObjectURL(blob);
    return url;
  }
};

export const getArrayBuffer = (file: RcFile, callbackGetResult: (result: ArrayBuffer) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callbackGetResult(reader.result as ArrayBuffer));
  reader.readAsArrayBuffer(file);
};

export const addDashesToNumber = (number: string) => {
  if (!number) return number;

  const numWithoutDashes = number.replace(/[^0-9]/g, '');

  if (numWithoutDashes.length > 10) return number.slice(0, -1);

  const dashPlaces = [3, 6];

  return numWithoutDashes
    .split('')
    .reduce((acc: string[], curr: string, i: number) => (dashPlaces.includes(i) ? [...acc, '-', curr] : [...acc, curr]), [])
    .join('');
};

export const dataURItoArrayBuffer = (dataURI: string) => {
  var byteString = atob(dataURI.split(',')[1]);

  var ab = new ArrayBuffer(byteString.length);

  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return ab;
};
